import { render, staticRenderFns } from "./InsightsVitals.vue?vue&type=template&id=6c0e8a2a&"
import script from "./InsightsVitals.vue?vue&type=script&lang=js&"
export * from "./InsightsVitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports